/******/ (() => {
  // webpackBootstrap
  /******/ "use strict";
  /******/ var __webpack_modules__ = {
    /***/ "./resources/app.ts":
      /*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./scripts/components/Consent/Consent */ "./resources/scripts/components/Consent/Consent.ts"
          );
        /* harmony import */ var _scripts_components_Wishlist_Wishlist__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./scripts/components/Wishlist/Wishlist */ "./resources/scripts/components/Wishlist/Wishlist.ts"
          );
        /* harmony import */ var _scripts_components_Wishlist_WishlistButton__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./scripts/components/Wishlist/WishlistButton */ "./resources/scripts/components/Wishlist/WishlistButton.ts"
          );

        customElements.define(
          "wishlist-button",
          _scripts_components_Wishlist_WishlistButton__WEBPACK_IMPORTED_MODULE_2__[
            "default"
          ]
        );
        customElements.define(
          "wishlist-component",
          _scripts_components_Wishlist_Wishlist__WEBPACK_IMPORTED_MODULE_1__[
            "default"
          ]
        );
        var consent =
          new _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_0__[
            "default"
          ]();
        consent.init();

        /***/
      },

    /***/ "./resources/scripts/components/Consent/Consent.ts":
      /*!*********************************************************!*\
  !*** ./resources/scripts/components/Consent/Consent.ts ***!
  \*********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ Consent,
          /* harmony export */
        });
        function _typeof(o) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o &&
                      "function" == typeof Symbol &&
                      o.constructor === Symbol &&
                      o !== Symbol.prototype
                      ? "symbol"
                      : typeof o;
                  }),
            _typeof(o)
          );
        }
        function _regenerator() {
          /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e,
            t,
            r = "function" == typeof Symbol ? Symbol : {},
            n = r.iterator || "@@iterator",
            o = r.toStringTag || "@@toStringTag";
          function i(r, n, o, i) {
            var c = n && n.prototype instanceof Generator ? n : Generator,
              u = Object.create(c.prototype);
            return (
              _regeneratorDefine2(
                u,
                "_invoke",
                (function (r, n, o) {
                  var i,
                    c,
                    u,
                    f = 0,
                    p = o || [],
                    y = !1,
                    G = {
                      p: 0,
                      n: 0,
                      v: e,
                      a: d,
                      f: d.bind(e, 4),
                      d: function d(t, r) {
                        return (i = t), (c = 0), (u = e), (G.n = r), a;
                      },
                    };
                  function d(r, n) {
                    for (
                      c = r, u = n, t = 0;
                      !y && f && !o && t < p.length;
                      t++
                    ) {
                      var o,
                        i = p[t],
                        d = G.p,
                        l = i[2];
                      r > 3
                        ? (o = l === n) &&
                          ((u = i[(c = i[4]) ? 5 : ((c = 3), 3)]),
                          (i[4] = i[5] = e))
                        : i[0] <= d &&
                          ((o = r < 2 && d < i[1])
                            ? ((c = 0), (G.v = n), (G.n = i[1]))
                            : d < l &&
                              (o = r < 3 || i[0] > n || n > l) &&
                              ((i[4] = r), (i[5] = n), (G.n = l), (c = 0)));
                    }
                    if (o || r > 1) return a;
                    throw ((y = !0), n);
                  }
                  return function (o, p, l) {
                    if (f > 1) throw TypeError("Generator is already running");
                    for (
                      y && 1 === p && d(p, l), c = p, u = l;
                      (t = c < 2 ? e : u) || !y;

                    ) {
                      i ||
                        (c
                          ? c < 3
                            ? (c > 1 && (G.n = -1), d(c, u))
                            : (G.n = u)
                          : (G.v = u));
                      try {
                        if (((f = 2), i)) {
                          if ((c || (o = "next"), (t = i[o]))) {
                            if (!(t = t.call(i, u)))
                              throw TypeError(
                                "iterator result is not an object"
                              );
                            if (!t.done) return t;
                            (u = t.value), c < 2 && (c = 0);
                          } else
                            1 === c && (t = i["return"]) && t.call(i),
                              c < 2 &&
                                ((u = TypeError(
                                  "The iterator does not provide a '" +
                                    o +
                                    "' method"
                                )),
                                (c = 1));
                          i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
                          break;
                      } catch (t) {
                        (i = e), (c = 1), (u = t);
                      } finally {
                        f = 1;
                      }
                    }
                    return { value: t, done: y };
                  };
                })(r, o, i),
                !0
              ),
              u
            );
          }
          var a = {};
          function Generator() {}
          function GeneratorFunction() {}
          function GeneratorFunctionPrototype() {}
          t = Object.getPrototypeOf;
          var c = [][n]
              ? t(t([][n]()))
              : (_regeneratorDefine2((t = {}), n, function () {
                  return this;
                }),
                t),
            u =
              (GeneratorFunctionPrototype.prototype =
              Generator.prototype =
                Object.create(c));
          function f(e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, GeneratorFunctionPrototype)
                : ((e.__proto__ = GeneratorFunctionPrototype),
                  _regeneratorDefine2(e, o, "GeneratorFunction")),
              (e.prototype = Object.create(u)),
              e
            );
          }
          return (
            (GeneratorFunction.prototype = GeneratorFunctionPrototype),
            _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype),
            _regeneratorDefine2(
              GeneratorFunctionPrototype,
              "constructor",
              GeneratorFunction
            ),
            (GeneratorFunction.displayName = "GeneratorFunction"),
            _regeneratorDefine2(
              GeneratorFunctionPrototype,
              o,
              "GeneratorFunction"
            ),
            _regeneratorDefine2(u),
            _regeneratorDefine2(u, o, "Generator"),
            _regeneratorDefine2(u, n, function () {
              return this;
            }),
            _regeneratorDefine2(u, "toString", function () {
              return "[object Generator]";
            }),
            (_regenerator = function _regenerator() {
              return { w: i, m: f };
            })()
          );
        }
        function _regeneratorDefine2(e, r, n, t) {
          var i = Object.defineProperty;
          try {
            i({}, "", {});
          } catch (e) {
            i = 0;
          }
          (_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
            function o(r, n) {
              _regeneratorDefine2(e, r, function (e) {
                return this._invoke(r, n, e);
              });
            }
            r
              ? i
                ? i(e, r, {
                    value: n,
                    enumerable: !t,
                    configurable: !t,
                    writable: !t,
                  })
                : (e[r] = n)
              : (o("next", 0), o("throw", 1), o("return", 2));
          }),
            _regeneratorDefine2(e, r, n, t);
        }
        function asyncGeneratorStep(n, t, e, r, o, a, c) {
          try {
            var i = n[a](c),
              u = i.value;
          } catch (n) {
            return void e(n);
          }
          i.done ? t(u) : Promise.resolve(u).then(r, o);
        }
        function _asyncToGenerator(n) {
          return function () {
            var t = this,
              e = arguments;
            return new Promise(function (r, o) {
              var a = n.apply(t, e);
              function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
              }
              function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
              }
              _next(void 0);
            });
          };
        }
        function _classCallCheck(a, n) {
          if (!(a instanceof n))
            throw new TypeError("Cannot call a class as a function");
        }
        function _defineProperties(e, r) {
          for (var t = 0; t < r.length; t++) {
            var o = r[t];
            (o.enumerable = o.enumerable || !1),
              (o.configurable = !0),
              "value" in o && (o.writable = !0),
              Object.defineProperty(e, _toPropertyKey(o.key), o);
          }
        }
        function _createClass(e, r, t) {
          return (
            r && _defineProperties(e.prototype, r),
            t && _defineProperties(e, t),
            Object.defineProperty(e, "prototype", { writable: !1 }),
            e
          );
        }
        function _toPropertyKey(t) {
          var i = _toPrimitive(t, "string");
          return "symbol" == _typeof(i) ? i : i + "";
        }
        function _toPrimitive(t, r) {
          if ("object" != _typeof(t) || !t) return t;
          var e = t[Symbol.toPrimitive];
          if (void 0 !== e) {
            var i = e.call(t, r || "default");
            if ("object" != _typeof(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === r ? String : Number)(t);
        }
        // Consent Component
        //
        // This class manages user consent tracking and interaction with Shopify's consent-tracking API.
        // It includes methods for initializing consent features, handling consent updates, and interacting
        // with Shopify's privacy settings.
        //
        // Key Functionalities:
        // - `init()`: Loads Shopify's consent-tracking API and initializes the consent component.
        // - `initConsentComponent()`: Sets up event listeners for consent actions, such as recalling consent preferences.
        // - `handleConsentUpdate(state: string)`: Updates consent settings based on the user's current preferences.
        //   - Parameters:
        //     - `state`: A string representing the consent state ("granted", "denied", etc.).
        // - `checkConsentBannerInteraction()`: Verifies if the user has interacted with the consent banner.
        // - `gtag(...args)`: Pushes consent-related events to the Google Tag Manager data layer.
        // - `recallConsent()`: Displays the privacy banner to allow users to update their consent preferences.
        // - `logConsent(consentSettings: object)`: Logs the user's consent preferences to a database or analytics tool.
        //
        // Dependencies:
        // - `window.dataLayer`: Required for Google Consent Mode V2 integration.
        // - Shopify Customer Privacy Banner: Must be enabled in the Shopify admin panel.
        //
        // Error Handling:
        // - Errors in loading Shopify features (e.g., API initialization failures) are logged to the console without blocking the process.
        //
        // Extensibility:
        // - Support additional consent categories or analytics tools by extending `handleConsentUpdate` and other methods.
        // - Update `logConsent` to integrate with custom databases or third-party analytics platforms as needed.
        //
        // Notes:
        // - Local storage is used to persist consent settings across sessions.
        // - Ensure GDPR/CCPA compliance by providing legally required opt-in/opt-out functionality and transparency.
        // - Refer to Shopify's privacy documentation for specific implementation requirements.
        //
        // Usage Example:
        // 1. Import the `Consent` class and initialize it in your application:
        // ---- import Consent from './scripts/components/Consent/Consent';
        // ---- const consent = new Consent();
        // ---- consent.init();
        //
        // 2. To enable the recall consent feature, add an element with the ID "recall-consent" to the DOM:
        // ---- <a href="#" id="recall-consent"></a>
        //
        // 3. Add Locales: en: "change_cookie_settings": "Change your cookie settings", da: "change_cookie_settings": "Tilpas dine cookie-indstillinger",
        var Consent = /*#__PURE__*/ (function () {
          // declare dataLayer
          function Consent() {
            _classCallCheck(this, Consent);
            this.init = this.init.bind(this);
            this.handleConsentUpdate = this.handleConsentUpdate.bind(this);
            this.checkConsentBannerInteraction =
              this.checkConsentBannerInteraction.bind(this);
            this.gtag = this.gtag.bind(this);
            this.recallConsent = this.recallConsent.bind(this);
            this.logConsent = this.logConsent.bind(this);
          }
          // methods
          return _createClass(Consent, [
            {
              key: "init",
              value: (function () {
                var _init = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee() {
                    var _this = this;
                    return _regenerator().w(function (_context) {
                      while (1)
                        switch (_context.n) {
                          case 0:
                            window.Shopify.loadFeatures(
                              [
                                {
                                  name: "consent-tracking-api",
                                  version: "0.1",
                                },
                              ],
                              function (error) {
                                if (error) {
                                  console.error(
                                    "Error loading features: ",
                                    error
                                  );
                                  return;
                                }
                                console.log("Consent tracking API loaded");
                                _this.initConsentComponent();
                              }
                            );
                          case 1:
                            return _context.a(2);
                        }
                    }, _callee);
                  })
                );
                function init() {
                  return _init.apply(this, arguments);
                }
                return init;
              })(),
            },
            {
              key: "initConsentComponent",
              value: (function () {
                var _initConsentComponent = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee3() {
                    var _this2 = this;
                    var recallConsentElement;
                    return _regenerator().w(function (_context3) {
                      while (1)
                        switch (_context3.n) {
                          case 0:
                            window.dataLayer = window.dataLayer || [];
                            document.addEventListener(
                              "visitorConsentCollected",
                              /*#__PURE__*/ _asyncToGenerator(
                                /*#__PURE__*/ _regenerator().m(
                                  function _callee2() {
                                    return _regenerator().w(function (
                                      _context2
                                    ) {
                                      while (1)
                                        switch (_context2.n) {
                                          case 0:
                                            _this2.handleConsentUpdate(
                                              "update"
                                            );
                                          case 1:
                                            return _context2.a(2);
                                        }
                                    },
                                    _callee2);
                                  }
                                )
                              )
                            );
                            recallConsentElement =
                              document.getElementById("recall-consent");
                            if (recallConsentElement) {
                              recallConsentElement.addEventListener(
                                "click",
                                function (event) {
                                  event.preventDefault();
                                  _this2.recallConsent();
                                }
                              );
                            }
                          case 1:
                            return _context3.a(2);
                        }
                    }, _callee3);
                  })
                );
                function initConsentComponent() {
                  return _initConsentComponent.apply(this, arguments);
                }
                return initConsentComponent;
              })(),
            },
            {
              key: "handleConsentUpdate",
              value: (function () {
                var _handleConsentUpdate = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee4(state) {
                    var visitorConsent, consent;
                    return _regenerator().w(
                      function (_context4) {
                        while (1)
                          switch (_context4.n) {
                            case 0:
                              _context4.n = 1;
                              return window.Shopify.customerPrivacy.currentVisitorConsent();
                            case 1:
                              visitorConsent = _context4.v;
                              consent = {
                                functionality_storage:
                                  visitorConsent.preferences === "yes"
                                    ? "granted"
                                    : "granted",
                                analytics_storage:
                                  visitorConsent.analytics === "yes"
                                    ? "granted"
                                    : "denied",
                                personalization_storage:
                                  visitorConsent.analytics === "yes"
                                    ? "granted"
                                    : "denied",
                                ad_storage:
                                  visitorConsent.marketing === "yes"
                                    ? "granted"
                                    : "denied",
                                ad_user_data:
                                  visitorConsent.marketing === "yes"
                                    ? "granted"
                                    : "denied",
                                ad_personalization:
                                  visitorConsent.marketing === "yes"
                                    ? "granted"
                                    : "denied",
                                wait_for_update: 3000,
                              };
                              this.gtag("consent", state, consent);
                              // set local Storage for consent settings for further use on other pages or after page
                              localStorage.setItem(
                                "consentSettings",
                                JSON.stringify(consent)
                              );
                              this.logConsent(consent);
                            case 2:
                              return _context4.a(2);
                          }
                      },
                      _callee4,
                      this
                    );
                  })
                );
                function handleConsentUpdate(_x) {
                  return _handleConsentUpdate.apply(this, arguments);
                }
                return handleConsentUpdate;
              })() /* eslint-disable */,
            },
            {
              key: "checkConsentBannerInteraction",
              value: (function () {
                var _checkConsentBannerInteraction = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee5() {
                    var visitorConsent;
                    return _regenerator().w(function (_context5) {
                      while (1)
                        switch (_context5.n) {
                          case 0:
                            _context5.n = 1;
                            return window.Shopify.customerPrivacy.currentVisitorConsent();
                          case 1:
                            visitorConsent = _context5.v;
                            if (
                              !(
                                visitorConsent.preferences === "" &&
                                visitorConsent.analytics === "" &&
                                visitorConsent.marketing === ""
                              )
                            ) {
                              _context5.n = 2;
                              break;
                            }
                            return _context5.a(2, false);
                          case 2:
                            return _context5.a(2, true);
                        }
                    }, _callee5);
                  })
                );
                function checkConsentBannerInteraction() {
                  return _checkConsentBannerInteraction.apply(this, arguments);
                }
                return checkConsentBannerInteraction;
              })(),
              /* eslint-disable */
              /* eslint-disable */
            },
            {
              key: "gtag",
              value: function gtag() {
                for (
                  var _len = arguments.length, args = new Array(_len), _key = 0;
                  _key < _len;
                  _key++
                ) {
                  args[_key] = arguments[_key];
                }
                window.dataLayer.push(arguments);
              },
              /* eslint-enable */
              /* eslint-disable */
            },
            {
              key: "recallConsent",
              value: (function () {
                var _recallConsent = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee6() {
                    return _regenerator().w(function (_context6) {
                      while (1)
                        switch (_context6.n) {
                          case 0:
                            window.privacyBanner.showPreferences();
                          case 1:
                            return _context6.a(2);
                        }
                    }, _callee6);
                  })
                );
                function recallConsent() {
                  return _recallConsent.apply(this, arguments);
                }
                return recallConsent;
              })() /* eslint-disable */,
            },
            {
              key: "logConsent",
              value: (function () {
                var _logConsent = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee7(
                    consentSettings
                  ) {
                    var _localStorage$getItem, userId, _t, _t2;
                    return _regenerator().w(
                      function (_context7) {
                        while (1)
                          switch ((_context7.p = _context7.n)) {
                            case 0:
                              _context7.p = 0;
                              if (
                                !(
                                  (_localStorage$getItem =
                                    localStorage.getItem("userId")) !== null &&
                                  _localStorage$getItem !== void 0
                                )
                              ) {
                                _context7.n = 1;
                                break;
                              }
                              _t = _localStorage$getItem;
                              _context7.n = 3;
                              break;
                            case 1:
                              _context7.n = 2;
                              return this.generateRandomHash();
                            case 2:
                              _t = _context7.v;
                            case 3:
                              userId = _t;
                              localStorage.setItem("userId", userId);
                              /* TODO: Add endpoint to log the users preferences for more compliance
                const logData = {
                user: USER_HERE,
                consentSettings,
                }
                       const response = await fetch('https://my-url/api/my-endpoint', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(data),
                });
                       if (!response.ok) {
                  throw new Error('Failed to log consent');
                }
                       const data = await response.json();
                console.log('Consent logged successfully: ', data);
                       COMMENT FOR ENDPOINT + DATABASE
                       When this event is recieved in the endpoint, the backend should first look at the website the request is coming from.
                If the request is coming from a website that is not allowed in our database, the request should be denied.
                This is to prevent unauthorized websites from logging consent settings, and to only allow websites that use our services to log consent settings.
                       After verifying the website, the backend should log the user's consent settings to a database
                If the user does not exist in the database, create a new entry for the user with the consent settings
                If the user exists in the database, update the user's consent settings with the new values
                       Database strucutre should be relational and could look like this:
                Each user / visitor belongs to a shop, and each shop can have multiple users / visitors
                Each user / visitor can have multiple consent settings
                       model: Shop
                       id | name | url | created_at | updated_at | user[]
                ---------------------------------------------------
                1  | Shop1| url1| 2021-09-01 | 2021-09-01 | [User1, User2, User3]
                       model: User
                       User | Functionality | Analytics | Personalization | Ad Storage | Ad User Data | Ad Personalization | created_at | updated_at | shop_id
                -------------------------------------------------------------------------------------------------------
                User1|    granted    |  granted  |     granted     |   granted  |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User2|    granted    |  denied   |     granted     |   denied   |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User3|    granted    |  granted  |     granted     |   granted  |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User4|    granted    |  denied   |     granted     |   denied   |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User5|    granted    |  granted  |     granted     |   granted  |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
                User6|    granted    |  denied   |     granted     |   denied   |    granted   |      granted       | 2021-09-01 12:00:00 | 2021-09-01 12:00:00 | 1
              */
                              _context7.n = 5;
                              break;
                            case 4:
                              _context7.p = 4;
                              _t2 = _context7.v;
                              console.error("Error logging consent: ", _t2);
                            case 5:
                              return _context7.a(2);
                          }
                      },
                      _callee7,
                      this,
                      [[0, 4]]
                    );
                  })
                );
                function logConsent(_x2) {
                  return _logConsent.apply(this, arguments);
                }
                return logConsent;
              })(),
            },
            {
              key: "generateRandomHash",
              value: (function () {
                var _generateRandomHash = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee8() {
                    var randomHash;
                    return _regenerator().w(function (_context8) {
                      while (1)
                        switch (_context8.n) {
                          case 0:
                            randomHash =
                              Math.random().toString(36).substring(2, 15) +
                              Math.random().toString(36).substring(2, 15);
                            return _context8.a(2, randomHash);
                        }
                    }, _callee8);
                  })
                );
                function generateRandomHash() {
                  return _generateRandomHash.apply(this, arguments);
                }
                return generateRandomHash;
              })(),
            },
          ]);
        })();

        /***/
      },

    /***/ "./resources/scripts/components/Wishlist/Wishlist.ts":
      /*!***********************************************************!*\
  !*** ./resources/scripts/components/Wishlist/Wishlist.ts ***!
  \***********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ Wishlist,
          /* harmony export */
        });
        function _typeof(o) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o &&
                      "function" == typeof Symbol &&
                      o.constructor === Symbol &&
                      o !== Symbol.prototype
                      ? "symbol"
                      : typeof o;
                  }),
            _typeof(o)
          );
        }
        function _regenerator() {
          /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e,
            t,
            r = "function" == typeof Symbol ? Symbol : {},
            n = r.iterator || "@@iterator",
            o = r.toStringTag || "@@toStringTag";
          function i(r, n, o, i) {
            var c = n && n.prototype instanceof Generator ? n : Generator,
              u = Object.create(c.prototype);
            return (
              _regeneratorDefine2(
                u,
                "_invoke",
                (function (r, n, o) {
                  var i,
                    c,
                    u,
                    f = 0,
                    p = o || [],
                    y = !1,
                    G = {
                      p: 0,
                      n: 0,
                      v: e,
                      a: d,
                      f: d.bind(e, 4),
                      d: function d(t, r) {
                        return (i = t), (c = 0), (u = e), (G.n = r), a;
                      },
                    };
                  function d(r, n) {
                    for (
                      c = r, u = n, t = 0;
                      !y && f && !o && t < p.length;
                      t++
                    ) {
                      var o,
                        i = p[t],
                        d = G.p,
                        l = i[2];
                      r > 3
                        ? (o = l === n) &&
                          ((u = i[(c = i[4]) ? 5 : ((c = 3), 3)]),
                          (i[4] = i[5] = e))
                        : i[0] <= d &&
                          ((o = r < 2 && d < i[1])
                            ? ((c = 0), (G.v = n), (G.n = i[1]))
                            : d < l &&
                              (o = r < 3 || i[0] > n || n > l) &&
                              ((i[4] = r), (i[5] = n), (G.n = l), (c = 0)));
                    }
                    if (o || r > 1) return a;
                    throw ((y = !0), n);
                  }
                  return function (o, p, l) {
                    if (f > 1) throw TypeError("Generator is already running");
                    for (
                      y && 1 === p && d(p, l), c = p, u = l;
                      (t = c < 2 ? e : u) || !y;

                    ) {
                      i ||
                        (c
                          ? c < 3
                            ? (c > 1 && (G.n = -1), d(c, u))
                            : (G.n = u)
                          : (G.v = u));
                      try {
                        if (((f = 2), i)) {
                          if ((c || (o = "next"), (t = i[o]))) {
                            if (!(t = t.call(i, u)))
                              throw TypeError(
                                "iterator result is not an object"
                              );
                            if (!t.done) return t;
                            (u = t.value), c < 2 && (c = 0);
                          } else
                            1 === c && (t = i["return"]) && t.call(i),
                              c < 2 &&
                                ((u = TypeError(
                                  "The iterator does not provide a '" +
                                    o +
                                    "' method"
                                )),
                                (c = 1));
                          i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
                          break;
                      } catch (t) {
                        (i = e), (c = 1), (u = t);
                      } finally {
                        f = 1;
                      }
                    }
                    return { value: t, done: y };
                  };
                })(r, o, i),
                !0
              ),
              u
            );
          }
          var a = {};
          function Generator() {}
          function GeneratorFunction() {}
          function GeneratorFunctionPrototype() {}
          t = Object.getPrototypeOf;
          var c = [][n]
              ? t(t([][n]()))
              : (_regeneratorDefine2((t = {}), n, function () {
                  return this;
                }),
                t),
            u =
              (GeneratorFunctionPrototype.prototype =
              Generator.prototype =
                Object.create(c));
          function f(e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, GeneratorFunctionPrototype)
                : ((e.__proto__ = GeneratorFunctionPrototype),
                  _regeneratorDefine2(e, o, "GeneratorFunction")),
              (e.prototype = Object.create(u)),
              e
            );
          }
          return (
            (GeneratorFunction.prototype = GeneratorFunctionPrototype),
            _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype),
            _regeneratorDefine2(
              GeneratorFunctionPrototype,
              "constructor",
              GeneratorFunction
            ),
            (GeneratorFunction.displayName = "GeneratorFunction"),
            _regeneratorDefine2(
              GeneratorFunctionPrototype,
              o,
              "GeneratorFunction"
            ),
            _regeneratorDefine2(u),
            _regeneratorDefine2(u, o, "Generator"),
            _regeneratorDefine2(u, n, function () {
              return this;
            }),
            _regeneratorDefine2(u, "toString", function () {
              return "[object Generator]";
            }),
            (_regenerator = function _regenerator() {
              return { w: i, m: f };
            })()
          );
        }
        function _regeneratorDefine2(e, r, n, t) {
          var i = Object.defineProperty;
          try {
            i({}, "", {});
          } catch (e) {
            i = 0;
          }
          (_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
            function o(r, n) {
              _regeneratorDefine2(e, r, function (e) {
                return this._invoke(r, n, e);
              });
            }
            r
              ? i
                ? i(e, r, {
                    value: n,
                    enumerable: !t,
                    configurable: !t,
                    writable: !t,
                  })
                : (e[r] = n)
              : (o("next", 0), o("throw", 1), o("return", 2));
          }),
            _regeneratorDefine2(e, r, n, t);
        }
        function asyncGeneratorStep(n, t, e, r, o, a, c) {
          try {
            var i = n[a](c),
              u = i.value;
          } catch (n) {
            return void e(n);
          }
          i.done ? t(u) : Promise.resolve(u).then(r, o);
        }
        function _asyncToGenerator(n) {
          return function () {
            var t = this,
              e = arguments;
            return new Promise(function (r, o) {
              var a = n.apply(t, e);
              function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
              }
              function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
              }
              _next(void 0);
            });
          };
        }
        function _classCallCheck(a, n) {
          if (!(a instanceof n))
            throw new TypeError("Cannot call a class as a function");
        }
        function _defineProperties(e, r) {
          for (var t = 0; t < r.length; t++) {
            var o = r[t];
            (o.enumerable = o.enumerable || !1),
              (o.configurable = !0),
              "value" in o && (o.writable = !0),
              Object.defineProperty(e, _toPropertyKey(o.key), o);
          }
        }
        function _createClass(e, r, t) {
          return (
            r && _defineProperties(e.prototype, r),
            t && _defineProperties(e, t),
            Object.defineProperty(e, "prototype", { writable: !1 }),
            e
          );
        }
        function _callSuper(t, o, e) {
          return (
            (o = _getPrototypeOf(o)),
            _possibleConstructorReturn(
              t,
              _isNativeReflectConstruct()
                ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor)
                : o.apply(t, e)
            )
          );
        }
        function _possibleConstructorReturn(t, e) {
          if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
          if (void 0 !== e)
            throw new TypeError(
              "Derived constructors may only return object or undefined"
            );
          return _assertThisInitialized(t);
        }
        function _assertThisInitialized(e) {
          if (void 0 === e)
            throw new ReferenceError(
              "this hasn't been initialised - super() hasn't been called"
            );
          return e;
        }
        function _inherits(t, e) {
          if ("function" != typeof e && null !== e)
            throw new TypeError(
              "Super expression must either be null or a function"
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            Object.defineProperty(t, "prototype", { writable: !1 }),
            e && _setPrototypeOf(t, e);
        }
        function _wrapNativeSuper(t) {
          var r = "function" == typeof Map ? new Map() : void 0;
          return (
            (_wrapNativeSuper = function _wrapNativeSuper(t) {
              if (null === t || !_isNativeFunction(t)) return t;
              if ("function" != typeof t)
                throw new TypeError(
                  "Super expression must either be null or a function"
                );
              if (void 0 !== r) {
                if (r.has(t)) return r.get(t);
                r.set(t, Wrapper);
              }
              function Wrapper() {
                return _construct(
                  t,
                  arguments,
                  _getPrototypeOf(this).constructor
                );
              }
              return (
                (Wrapper.prototype = Object.create(t.prototype, {
                  constructor: {
                    value: Wrapper,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0,
                  },
                })),
                _setPrototypeOf(Wrapper, t)
              );
            }),
            _wrapNativeSuper(t)
          );
        }
        function _construct(t, e, r) {
          if (_isNativeReflectConstruct())
            return Reflect.construct.apply(null, arguments);
          var o = [null];
          o.push.apply(o, e);
          var p = new (t.bind.apply(t, o))();
          return r && _setPrototypeOf(p, r.prototype), p;
        }
        function _isNativeReflectConstruct() {
          try {
            var t = !Boolean.prototype.valueOf.call(
              Reflect.construct(Boolean, [], function () {})
            );
          } catch (t) {}
          return (_isNativeReflectConstruct =
            function _isNativeReflectConstruct() {
              return !!t;
            })();
        }
        function _isNativeFunction(t) {
          try {
            return -1 !== Function.toString.call(t).indexOf("[native code]");
          } catch (n) {
            return "function" == typeof t;
          }
        }
        function _setPrototypeOf(t, e) {
          return (
            (_setPrototypeOf = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (t, e) {
                  return (t.__proto__ = e), t;
                }),
            _setPrototypeOf(t, e)
          );
        }
        function _getPrototypeOf(t) {
          return (
            (_getPrototypeOf = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (t) {
                  return t.__proto__ || Object.getPrototypeOf(t);
                }),
            _getPrototypeOf(t)
          );
        }
        function _defineProperty(e, r, t) {
          return (
            (r = _toPropertyKey(r)) in e
              ? Object.defineProperty(e, r, {
                  value: t,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (e[r] = t),
            e
          );
        }
        function _toPropertyKey(t) {
          var i = _toPrimitive(t, "string");
          return "symbol" == _typeof(i) ? i : i + "";
        }
        function _toPrimitive(t, r) {
          if ("object" != _typeof(t) || !t) return t;
          var e = t[Symbol.toPrimitive];
          if (void 0 !== e) {
            var i = e.call(t, r || "default");
            if ("object" != _typeof(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === r ? String : Number)(t);
        }
        /* eslint-disable no-empty */
        /* eslint-disable class-methods-use-this */
        var Wishlist = /*#__PURE__*/ (function (_HTMLElement) {
          function Wishlist() {
            var _this;
            _classCallCheck(this, Wishlist);
            _this = _callSuper(this, Wishlist);
            _defineProperty(_this, "url", _this.dataset.url);
            _this.addEventListeners = _this.addEventListeners.bind(_this);
            _this.handleShareWishlist = _this.handleShareWishlist.bind(_this);
            _this.setCounter = _this.setCounter.bind(_this);
            _this.renderWishlistItems = _this.renderWishlistItems.bind(_this);
            _this.generateWishlistItems =
              _this.generateWishlistItems.bind(_this);
            _this.createSkeletonLoader = _this.createSkeletonLoader.bind(_this);
            _this.checkForSharedWishlist =
              _this.checkForSharedWishlist.bind(_this);
            _this.showOrHideSubtitle = _this.showOrHideSubtitle.bind(_this);
            return _this;
          }
          _inherits(Wishlist, _HTMLElement);
          return _createClass(Wishlist, [
            {
              key: "connectedCallback",
              value: (function () {
                var _connectedCallback = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee() {
                    var currentWishlist, parsedWishlist;
                    return _regenerator().w(
                      function (_context) {
                        while (1)
                          switch (_context.n) {
                            case 0:
                              this.addEventListeners();
                              _context.n = 1;
                              return this.renderWishlistItems();
                            case 1:
                              currentWishlist =
                                localStorage.getItem("wishlist");
                              parsedWishlist = currentWishlist
                                ? JSON.parse(currentWishlist)
                                : [];
                              this.setCounter(parsedWishlist.length);
                              this.showOrHideSubtitle();
                            case 2:
                              return _context.a(2);
                          }
                      },
                      _callee,
                      this
                    );
                  })
                );
                function connectedCallback() {
                  return _connectedCallback.apply(this, arguments);
                }
                return connectedCallback;
              })(),
            },
            {
              key: "addEventListeners",
              value: function addEventListeners() {
                var _this2 = this;
                var shareButton = document.getElementById("share-wishlist");
                if (shareButton) {
                  shareButton.addEventListener("click", function (event) {
                    event.preventDefault();
                    _this2.handleShareWishlist();
                  });
                }
                this.checkForSharedWishlist();
                document.addEventListener(
                  "wishlistUpdated",
                  /*#__PURE__*/ (function () {
                    var _ref = _asyncToGenerator(
                      /*#__PURE__*/ _regenerator().m(function _callee2(event) {
                        return _regenerator().w(function (_context2) {
                          while (1)
                            switch (_context2.n) {
                              case 0:
                                _this2.setCounter(event.detail.wishlistCount);
                                _context2.n = 1;
                                return _this2.renderWishlistItems();
                              case 1:
                                _this2.showOrHideSubtitle();
                              case 2:
                                return _context2.a(2);
                            }
                        }, _callee2);
                      })
                    );
                    return function (_x) {
                      return _ref.apply(this, arguments);
                    };
                  })()
                );
                document.addEventListener(
                  "DOMContentLoaded",
                  /*#__PURE__*/ _asyncToGenerator(
                    /*#__PURE__*/ _regenerator().m(function _callee3() {
                      return _regenerator().w(function (_context3) {
                        while (1)
                          switch (_context3.n) {
                            case 0:
                              _this2.showOrHideSubtitle();
                            case 1:
                              return _context3.a(2);
                          }
                      }, _callee3);
                    })
                  )
                );
              },
            },
            {
              key: "showOrHideSubtitle",
              value: function showOrHideSubtitle() {
                var wishlistCount = 0;
                var subtitle = document.querySelector(".wishlist-subtitle");
                var currentWishlist = localStorage.getItem("wishlist");
                var parsedWishlist = currentWishlist
                  ? JSON.parse(currentWishlist)
                  : [];
                wishlistCount = parsedWishlist.length || 0;
                if (subtitle) {
                  if (wishlistCount === 0) {
                    subtitle.classList.remove("tw-hidden");
                  } else {
                    subtitle.classList.add("tw-hidden");
                  }
                }
              },
            },
            {
              key: "renderWishlistItems",
              value: (function () {
                var _renderWishlistItems = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee4() {
                    var _this3 = this;
                    var currentWishlist, parsedWishlist, wishlistItemsHtml;
                    return _regenerator().w(
                      function (_context4) {
                        while (1)
                          switch (_context4.n) {
                            case 0:
                              currentWishlist =
                                localStorage.getItem("wishlist");
                              parsedWishlist = currentWishlist
                                ? JSON.parse(currentWishlist)
                                : []; // clear the content of the wishlist-items element
                              this.innerHTML = "";
                              if (!(parsedWishlist.length === 0)) {
                                _context4.n = 1;
                                break;
                              }
                              return _context4.a(2);
                            case 1:
                              this.innerHTML = "\n      ".concat(
                                parsedWishlist
                                  .map(function () {
                                    return _this3.createSkeletonLoader();
                                  })
                                  .join(""),
                                "\n  "
                              );
                              _context4.n = 2;
                              return this.generateWishlistItems(parsedWishlist);
                            case 2:
                              wishlistItemsHtml = _context4.v;
                              this.innerHTML = wishlistItemsHtml;
                            case 3:
                              return _context4.a(2);
                          }
                      },
                      _callee4,
                      this
                    );
                  })
                );
                function renderWishlistItems() {
                  return _renderWishlistItems.apply(this, arguments);
                }
                return renderWishlistItems;
              })(),
            },
            {
              key: "generateWishlistItems",
              value: (function () {
                var _generateWishlistItems = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee5(
                    parsedWishlist
                  ) {
                    var _this4 = this;
                    var batchSize,
                      batches,
                      idsArray,
                      i,
                      responses,
                      template,
                      wishlitItemsHtml,
                      _t;
                    return _regenerator().w(
                      function (_context5) {
                        while (1)
                          switch ((_context5.p = _context5.n)) {
                            case 0:
                              _context5.p = 0;
                              batchSize = 20;
                              batches = [];
                              idsArray = parsedWishlist.map(function (id) {
                                return "id:".concat(id);
                              });
                              for (i = 0; i < idsArray.length; i += batchSize) {
                                batches.push(
                                  idsArray.slice(i, i + batchSize).join(" OR ")
                                );
                              }
                              _context5.n = 1;
                              return Promise.all(
                                batches.map(function (batchQuery) {
                                  return fetch(
                                    ""
                                      .concat(_this4.url, "&q=")
                                      .concat(batchQuery)
                                  ).then(function (res) {
                                    if (!res.ok)
                                      throw new Error(
                                        "Network response was not ok"
                                      );
                                    return res.text();
                                  });
                                })
                              );
                            case 1:
                              responses = _context5.v;
                              template = document.createElement("template");
                              wishlitItemsHtml = responses
                                .map(function (response) {
                                  template.innerHTML = response;
                                  var wishlistItemsWrapper =
                                    template.content.querySelector(
                                      "wishlist-component"
                                    );
                                  return wishlistItemsWrapper
                                    ? Array.from(wishlistItemsWrapper.children)
                                        .map(function (child) {
                                          return child.outerHTML;
                                        })
                                        .join("")
                                    : "";
                                })
                                .join("");
                              return _context5.a(2, wishlitItemsHtml);
                            case 2:
                              _context5.p = 2;
                              _t = _context5.v;
                              // eslint-disable-next-line no-console
                              console.error(_t);
                              return _context5.a(2, "");
                          }
                      },
                      _callee5,
                      null,
                      [[0, 2]]
                    );
                  })
                );
                function generateWishlistItems(_x2) {
                  return _generateWishlistItems.apply(this, arguments);
                }
                return generateWishlistItems;
              })(),
            },
            {
              key: "createSkeletonLoader",
              value: function createSkeletonLoader() {
                return '\n      <div class="tw-animate-pulse tw-rounded-lg tw-border tw-bg-gray-200 tw-shadow-md tw-overflow-hidden">\n        <div class="tw-w-full tw-h-[165px] tw-md:h-[250px] tw-bg-gray-300 !tw-block"></div>\n        <div class="tw-p-6 tw-flex tw-flex-col tw-gap-4">\n          <div class="tw-w-3/4 tw-h-6 tw-bg-gray-300 tw-rounded !tw-block"></div>\n          <div class="tw-w-1/2 tw-h-4 tw-bg-gray-300 tw-rounded !tw-block"></div>\n          <div class="tw-w-1/3 tw-h-4 tw-bg-gray-300 tw-rounded !tw-block"></div>\n          <div class="tw-w-1/4 tw-h-4 tw-bg-gray-300 tw-rounded !tw-block"></div>\n          <div class="tw-w-1/2 tw-h-4 tw-bg-gray-300 tw-rounded !tw-block"></div>\n          <div class="tw-w-1/3 tw-h-4 tw-bg-gray-300 tw-rounded !tw-block"></div>\n          <div class="tw-w-1/4 tw-h-4 tw-bg-gray-300 tw-rounded !tw-block"></div>\n          <div class="tw-w-1/2 tw-h-4 tw-bg-gray-300 tw-rounded !tw-block"></div>\n          <div class="tw-w-full tw-h-10 tw-bg-gray-300 tw-rounded !tw-block"></div>\n          <div class="tw-w-1/2 tw-h-4 tw-mx-auto tw-bg-gray-300 tw-rounded !tw-block"></div>\n        </div>\n      </div>\n    ';
              },
            },
            {
              key: "checkForSharedWishlist",
              value: function checkForSharedWishlist() {
                var url = new URL(window.location.href);
                var params = new URLSearchParams(url.search);
                var wishlist = params.get("wishlist");
                if (wishlist) {
                }
              },
            },
            {
              key: "handleShareWishlist",
              value: (function () {
                var _handleShareWishlist = _asyncToGenerator(
                  /*#__PURE__*/ _regenerator().m(function _callee6() {
                    var currentWishlist, parsedWishlist, queryString, shareUrl;
                    return _regenerator().w(function (_context6) {
                      while (1)
                        switch (_context6.n) {
                          case 0:
                            currentWishlist = localStorage.getItem("wishlist");
                            parsedWishlist = currentWishlist
                              ? JSON.parse(currentWishlist)
                              : [];
                            if (!(parsedWishlist.length === 0)) {
                              _context6.n = 1;
                              break;
                            }
                            return _context6.a(2);
                          case 1:
                            queryString = parsedWishlist.join(",");
                            shareUrl = ""
                              .concat(window.location.href, "?wishlist=")
                              .concat(queryString); // copy to clipboard
                            _context6.n = 2;
                            return navigator.clipboard.writeText(shareUrl);
                          case 2:
                            return _context6.a(2);
                        }
                    }, _callee6);
                  })
                );
                function handleShareWishlist() {
                  return _handleShareWishlist.apply(this, arguments);
                }
                return handleShareWishlist;
              })(),
            },
            {
              key: "setCounter",
              value: function setCounter(count) {
                var counter = document.getElementById("counter-indicator");
                if (!counter) return;
                counter.textContent = count.toString();
                counter.classList.toggle("tw-hidden", count === 0);
                counter.classList.toggle("tw-flex", count > 0);
              },
            },
          ]);
        })(/*#__PURE__*/ _wrapNativeSuper(HTMLElement));

        /***/
      },

    /***/ "./resources/scripts/components/Wishlist/WishlistButton.ts":
      /*!*****************************************************************!*\
  !*** ./resources/scripts/components/Wishlist/WishlistButton.ts ***!
  \*****************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ WishlistButton,
          /* harmony export */
        });
        function _typeof(o) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (o) {
                    return typeof o;
                  }
                : function (o) {
                    return o &&
                      "function" == typeof Symbol &&
                      o.constructor === Symbol &&
                      o !== Symbol.prototype
                      ? "symbol"
                      : typeof o;
                  }),
            _typeof(o)
          );
        }
        function _classCallCheck(a, n) {
          if (!(a instanceof n))
            throw new TypeError("Cannot call a class as a function");
        }
        function _defineProperties(e, r) {
          for (var t = 0; t < r.length; t++) {
            var o = r[t];
            (o.enumerable = o.enumerable || !1),
              (o.configurable = !0),
              "value" in o && (o.writable = !0),
              Object.defineProperty(e, _toPropertyKey(o.key), o);
          }
        }
        function _createClass(e, r, t) {
          return (
            r && _defineProperties(e.prototype, r),
            t && _defineProperties(e, t),
            Object.defineProperty(e, "prototype", { writable: !1 }),
            e
          );
        }
        function _callSuper(t, o, e) {
          return (
            (o = _getPrototypeOf(o)),
            _possibleConstructorReturn(
              t,
              _isNativeReflectConstruct()
                ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor)
                : o.apply(t, e)
            )
          );
        }
        function _possibleConstructorReturn(t, e) {
          if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
          if (void 0 !== e)
            throw new TypeError(
              "Derived constructors may only return object or undefined"
            );
          return _assertThisInitialized(t);
        }
        function _assertThisInitialized(e) {
          if (void 0 === e)
            throw new ReferenceError(
              "this hasn't been initialised - super() hasn't been called"
            );
          return e;
        }
        function _inherits(t, e) {
          if ("function" != typeof e && null !== e)
            throw new TypeError(
              "Super expression must either be null or a function"
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            Object.defineProperty(t, "prototype", { writable: !1 }),
            e && _setPrototypeOf(t, e);
        }
        function _wrapNativeSuper(t) {
          var r = "function" == typeof Map ? new Map() : void 0;
          return (
            (_wrapNativeSuper = function _wrapNativeSuper(t) {
              if (null === t || !_isNativeFunction(t)) return t;
              if ("function" != typeof t)
                throw new TypeError(
                  "Super expression must either be null or a function"
                );
              if (void 0 !== r) {
                if (r.has(t)) return r.get(t);
                r.set(t, Wrapper);
              }
              function Wrapper() {
                return _construct(
                  t,
                  arguments,
                  _getPrototypeOf(this).constructor
                );
              }
              return (
                (Wrapper.prototype = Object.create(t.prototype, {
                  constructor: {
                    value: Wrapper,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0,
                  },
                })),
                _setPrototypeOf(Wrapper, t)
              );
            }),
            _wrapNativeSuper(t)
          );
        }
        function _construct(t, e, r) {
          if (_isNativeReflectConstruct())
            return Reflect.construct.apply(null, arguments);
          var o = [null];
          o.push.apply(o, e);
          var p = new (t.bind.apply(t, o))();
          return r && _setPrototypeOf(p, r.prototype), p;
        }
        function _isNativeReflectConstruct() {
          try {
            var t = !Boolean.prototype.valueOf.call(
              Reflect.construct(Boolean, [], function () {})
            );
          } catch (t) {}
          return (_isNativeReflectConstruct =
            function _isNativeReflectConstruct() {
              return !!t;
            })();
        }
        function _isNativeFunction(t) {
          try {
            return -1 !== Function.toString.call(t).indexOf("[native code]");
          } catch (n) {
            return "function" == typeof t;
          }
        }
        function _setPrototypeOf(t, e) {
          return (
            (_setPrototypeOf = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (t, e) {
                  return (t.__proto__ = e), t;
                }),
            _setPrototypeOf(t, e)
          );
        }
        function _getPrototypeOf(t) {
          return (
            (_getPrototypeOf = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (t) {
                  return t.__proto__ || Object.getPrototypeOf(t);
                }),
            _getPrototypeOf(t)
          );
        }
        function _defineProperty(e, r, t) {
          return (
            (r = _toPropertyKey(r)) in e
              ? Object.defineProperty(e, r, {
                  value: t,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (e[r] = t),
            e
          );
        }
        function _toPropertyKey(t) {
          var i = _toPrimitive(t, "string");
          return "symbol" == _typeof(i) ? i : i + "";
        }
        function _toPrimitive(t, r) {
          if ("object" != _typeof(t) || !t) return t;
          var e = t[Symbol.toPrimitive];
          if (void 0 !== e) {
            var i = e.call(t, r || "default");
            if ("object" != _typeof(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === r ? String : Number)(t);
        }
        var WishlistButton = /*#__PURE__*/ (function (_HTMLElement) {
          function WishlistButton() {
            var _this;
            _classCallCheck(this, WishlistButton);
            _this = _callSuper(this, WishlistButton);
            _defineProperty(_this, "id", _this.dataset.id);
            _this.addEventListeners = _this.addEventListeners.bind(_this);
            _this.toggleProductInWishlist =
              _this.toggleProductInWishlist.bind(_this);
            _this.checkIfProductIsInWishlist =
              _this.checkIfProductIsInWishlist.bind(_this);
            return _this;
          }
          _inherits(WishlistButton, _HTMLElement);
          return _createClass(WishlistButton, [
            {
              key: "connectedCallback",
              value: function connectedCallback() {
                this.checkIfProductIsInWishlist();
                this.addEventListeners();
              },
            },
            {
              key: "addEventListeners",
              value: function addEventListeners() {
                var _this2 = this;
                this.addEventListener("click", function (event) {
                  event.preventDefault();
                  _this2.toggleProductInWishlist();
                  _this2.animateWishlistButton(event);
                });
              },
            },
            {
              key: "toggleProductInWishlist",
              value: function toggleProductInWishlist() {
                var _this3 = this;
                var wishlist = localStorage.getItem("wishlist");
                var parsedWishlist = wishlist ? JSON.parse(wishlist) : [];
                // Wishlist is an array of handles
                var productIndex = parsedWishlist.findIndex(function (item) {
                  return item === _this3.id;
                });
                if (productIndex !== -1) {
                  parsedWishlist.splice(productIndex, 1); // Remove product
                } else {
                  parsedWishlist.push(this.id); // Add product
                }
                localStorage.setItem(
                  "wishlist",
                  JSON.stringify(parsedWishlist)
                );
                this.classList.toggle("added-to-wishlist");
                // Dispatch event to update wishlist count
                var wishlistUpdatedEvent = new CustomEvent("wishlistUpdated", {
                  detail: {
                    wishlistCount: parsedWishlist.length,
                    rerender: true,
                  },
                });
                document.dispatchEvent(wishlistUpdatedEvent);
              },
            },
            {
              key: "checkIfProductIsInWishlist",
              value: function checkIfProductIsInWishlist() {
                var wishlist = localStorage.getItem("wishlist");
                if (wishlist) {
                  var parsedWishlist = JSON.parse(wishlist);
                  if (parsedWishlist.includes(this.id)) {
                    this.classList.add("added-to-wishlist");
                  }
                }
              },
            },
            {
              key: "animateWishlistButton",
              value: function animateWishlistButton(event) {
                var particleWrapper = this.querySelector(".particles-wrapper");
                if (!particleWrapper) return;
                // Get the correct coordinates based on the event type
                var clientX;
                var clientY;
                if (event instanceof MouseEvent) {
                  clientX = event.clientX;
                  clientY = event.clientY;
                } else if (event instanceof TouchEvent) {
                  clientX = event.touches[0].clientX;
                  clientY = event.touches[0].clientY;
                } else {
                  return;
                }
                // Calculate position relative to particleWrapper
                var rect = particleWrapper.getBoundingClientRect();
                var offsetX = clientX - rect.left;
                var offsetY = clientY - rect.top;
                var _loop = function _loop() {
                  var particle = document.createElement("div");
                  particle.classList.add("particles");
                  // Randomize movement direction
                  var angle = Math.random() * 2 * Math.PI;
                  var distance = Math.random() * 20 + 10; // Spread particles outwards
                  var x = Math.cos(angle) * distance;
                  var y = Math.sin(angle) * distance;
                  // Position relative to click/touch
                  particle.style.left = "".concat(offsetX, "px");
                  particle.style.top = "".concat(offsetY, "px");
                  particle.style.setProperty("--x", "".concat(x, "px"));
                  particle.style.setProperty("--y", "".concat(y, "px"));
                  particleWrapper.appendChild(particle);
                  // Remove particle after animation (matching duration in CSS)
                  setTimeout(function () {
                    return particle.remove();
                  }, 2000);
                };
                for (var i = 0; i < 15; i += 1) {
                  _loop();
                }
              },
            },
          ]);
        })(/*#__PURE__*/ _wrapNativeSuper(HTMLElement));

        /***/
      },

    /***/ "./resources/styles/app.css":
      /*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        __webpack_require__.r(__webpack_exports__);
        // extracted by mini-css-extract-plugin

        /***/
      },

    /******/
  };
  /************************************************************************/
  /******/ // The module cache
  /******/ var __webpack_module_cache__ = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/ var cachedModule = __webpack_module_cache__[moduleId];
    /******/ if (cachedModule !== undefined) {
      /******/ return cachedModule.exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (__webpack_module_cache__[moduleId] = {
      /******/ // no module.id needed
      /******/ // no module.loaded needed
      /******/ exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ __webpack_modules__[moduleId](
      module,
      module.exports,
      __webpack_require__
    );
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/ __webpack_require__.m = __webpack_modules__;
  /******/
  /************************************************************************/
  /******/ /* webpack/runtime/chunk loaded */
  /******/ (() => {
    /******/ var deferred = [];
    /******/ __webpack_require__.O = (result, chunkIds, fn, priority) => {
      /******/ if (chunkIds) {
        /******/ priority = priority || 0;
        /******/ for (
          var i = deferred.length;
          i > 0 && deferred[i - 1][2] > priority;
          i--
        )
          deferred[i] = deferred[i - 1];
        /******/ deferred[i] = [chunkIds, fn, priority];
        /******/ return;
        /******/
      }
      /******/ var notFulfilled = Infinity;
      /******/ for (var i = 0; i < deferred.length; i++) {
        /******/ var [chunkIds, fn, priority] = deferred[i];
        /******/ var fulfilled = true;
        /******/ for (var j = 0; j < chunkIds.length; j++) {
          /******/ if (
            (priority & (1 === 0) || notFulfilled >= priority) &&
            Object.keys(__webpack_require__.O).every((key) =>
              __webpack_require__.O[key](chunkIds[j])
            )
          ) {
            /******/ chunkIds.splice(j--, 1);
            /******/
          } else {
            /******/ fulfilled = false;
            /******/ if (priority < notFulfilled) notFulfilled = priority;
            /******/
          }
          /******/
        }
        /******/ if (fulfilled) {
          /******/ deferred.splice(i--, 1);
          /******/ var r = fn();
          /******/ if (r !== undefined) result = r;
          /******/
        }
        /******/
      }
      /******/ return result;
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/define property getters */
  /******/ (() => {
    /******/ // define getter functions for harmony exports
    /******/ __webpack_require__.d = (exports, definition) => {
      /******/ for (var key in definition) {
        /******/ if (
          __webpack_require__.o(definition, key) &&
          !__webpack_require__.o(exports, key)
        ) {
          /******/ Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key],
          });
          /******/
        }
        /******/
      }
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/hasOwnProperty shorthand */
  /******/ (() => {
    /******/ __webpack_require__.o = (obj, prop) =>
      Object.prototype.hasOwnProperty.call(obj, prop);
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/make namespace object */
  /******/ (() => {
    /******/ // define __esModule on exports
    /******/ __webpack_require__.r = (exports) => {
      /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
        /******/ Object.defineProperty(exports, Symbol.toStringTag, {
          value: "Module",
        });
        /******/
      }
      /******/ Object.defineProperty(exports, "__esModule", { value: true });
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/jsonp chunk loading */
  /******/ (() => {
    /******/ // no baseURI
    /******/
    /******/ // object to store loaded and loading chunks
    /******/ // undefined = chunk not loaded, null = chunk preloaded/prefetched
    /******/ // [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
    /******/ var installedChunks = {
      /******/ "/shopify-theme/assets/edition": 0,
      /******/ "shopify-theme/assets/edition": 0,
      /******/
    };
    /******/
    /******/ // no chunk on demand loading
    /******/
    /******/ // no prefetching
    /******/
    /******/ // no preloaded
    /******/
    /******/ // no HMR
    /******/
    /******/ // no HMR manifest
    /******/
    /******/ __webpack_require__.O.j = (chunkId) =>
      installedChunks[chunkId] === 0;
    /******/
    /******/ // install a JSONP callback for chunk loading
    /******/ var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
      /******/ var [chunkIds, moreModules, runtime] = data;
      /******/ // add "moreModules" to the modules object,
      /******/ // then flag all "chunkIds" as loaded and fire callback
      /******/ var moduleId,
        chunkId,
        i = 0;
      /******/ if (chunkIds.some((id) => installedChunks[id] !== 0)) {
        /******/ for (moduleId in moreModules) {
          /******/ if (__webpack_require__.o(moreModules, moduleId)) {
            /******/ __webpack_require__.m[moduleId] = moreModules[moduleId];
            /******/
          }
          /******/
        }
        /******/ if (runtime) var result = runtime(__webpack_require__);
        /******/
      }
      /******/ if (parentChunkLoadingFunction) parentChunkLoadingFunction(data);
      /******/ for (; i < chunkIds.length; i++) {
        /******/ chunkId = chunkIds[i];
        /******/ if (
          __webpack_require__.o(installedChunks, chunkId) &&
          installedChunks[chunkId]
        ) {
          /******/ installedChunks[chunkId][0]();
          /******/
        }
        /******/ installedChunks[chunkId] = 0;
        /******/
      }
      /******/ return __webpack_require__.O(result);
      /******/
    };
    /******/
    /******/ var chunkLoadingGlobal = (self["webpackChunkdanefae"] =
      self["webpackChunkdanefae"] || []);
    /******/ chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
    /******/ chunkLoadingGlobal.push = webpackJsonpCallback.bind(
      null,
      chunkLoadingGlobal.push.bind(chunkLoadingGlobal)
    );
    /******/
  })();
  /******/
  /************************************************************************/
  /******/
  /******/ // startup
  /******/ // Load entry module and return exports
  /******/ // This entry module depends on other loaded chunks and execution need to be delayed
  /******/ __webpack_require__.O(
    undefined,
    ["shopify-theme/assets/edition"],
    () => __webpack_require__("./resources/app.ts")
  );
  /******/ var __webpack_exports__ = __webpack_require__.O(
    undefined,
    ["shopify-theme/assets/edition"],
    () => __webpack_require__("./resources/styles/app.css")
  );
  /******/ __webpack_exports__ = __webpack_require__.O(__webpack_exports__);
  /******/
  /******/
})();
